import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useUpgrade } from '../../context/UpgradeContext';

const STORAGE_KEY = 'aura_free_plan_chat_banner_dismissed';

const FreePlanChatBanner = () => {
  const navigate = useNavigate();
  const { permissions } = useUpgrade();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed || permissions?.can_access_full_ai) {
    return null;
  }

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="px-4 py-3 border-b border-hairline bg-[#f5e6c8] text-ink shrink-0 relative">
      <p className="text-body pr-8 leading-snug">
        You&apos;re on the free plan. Aura&apos;s advice is general — not based on your numbers.{' '}
        <button
          type="button"
          onClick={() => navigate('/upgrade?tier=pro')}
          className="text-pine font-medium hover:underline"
        >
          Upgrade for personalised advice →
        </button>
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="absolute top-2 right-2 p-1 rounded-md hover:bg-ink/5"
        aria-label="Dismiss"
      >
        <XMarkIcon className="w-4 h-4 text-ink-muted" />
      </button>
    </div>
  );
};

export default FreePlanChatBanner;
